var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-card-container",class:{ 'disabled': _vm.isDisabled }},[_c('div',{staticClass:"icon-container",class:{ 'selected': _vm.isSelected }},[_c('div',{staticClass:"icon"},[_c('i',{class:_vm.styles.icon})])]),_c('div',{staticClass:"type"},[_vm._v(" "+_vm._s(_vm.styles.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }